<script>
const IsraelBinList=[364094,364095,364096,372685,374580,375509,375510,375511,375512,375513,375514,375515,375516,375517,375518,375519,400159,405611,406423,407516,407517,407518,410927,419265,419266,419267,419268,421910,421911,421912,421913,421914,421915,428565,428566,428567,428568,431905,431906,431907,440303,455743,455744,458000,458001,458002,458003,458004,458005,458006,458007,458008,458009,458010,458011,458012,458013,458014,458015,458016,458017,458018,458019,458020,458021,458022,458023,458024,458025,458026,458027,458028,458029,458030,458031,458032,458033,458034,458035,458036,458037,458038,458039,458041,458042,458043,458044,458045,458047,458048,458049,458050,458051,458052,458053,458054,458055,458057,458078,458079,458080,458081,458082,458083,458085,458086,458087,458090,458091,458092,458093,458094,458095,458096,458097,458098,458099,459440,459523,480982,480983,480984,494055,494056,510046,510049,518953,518954,518955,518986,518987,518989,518991,532610,532611,532612,532613,532614,532615,532616,532617,532618,532619,533212,536406,536407,540124,544075,545134,545136,545138,547707,547714,547718,549212,552176,552177,552183,552184,552517,555953,558331,558449,601973,458056,511891,586739];

//Sourced from https://bincheck.org/israel on 2018-04-09, unchanged on 2018-01-09. 158 BINs Found -- sort it to match it up.
//458056 added on 2019-09-23 that's missing on bincheck. Stripe confirms it.
//added on 2021-06-30 via bincodes.com search:
//375509/375518/375519 amex
//364094,364095,364096 Diners club
//586739 maestro

export let credit_card_number='';
export let expiry_month='';
export let expiry_year='';
export let card_type='';

export let ask_security_code=false;
export let security_code='';
export let show_card_types=true;


let card_type_nice ='';
//export var allowedList=['american-express','visa','mastercard','yisracard'];


$: IsraeliCard=(card_type=='yisracard') 
	|| (credit_card_number && credit_card_number.length && IsraelBinList.includes(Number(credit_card_number.slice(0,6))));

import Fa from 'svelte-fa'
import { faExclamationCircle} from '@fortawesome/free-solid-svg-icons'; //faCreditCard
//import { faCcVisa, faCcAmex, faCcDiscover, faCcDinersClub, faCcMastercard, faCcJcb } from '@fortawesome/free-brands-svg-icons';

let expiry;
if(expiry_month && expiry_year) {//reinstantiate display value from bound variadles
	expiry = expiry_month + ' / ' + expiry_year;
	}

let credit_card_number_valid=undefined;
let expiry_valid=undefined;
export let valid=undefined;
$: valid = expiry_valid && credit_card_number_valid;

import cardValid from 'card-validator';
//$: check_card(loose,credit_card_number)
function check_card(typeOfCheck){
	//console.log(credit_card_number);

	if(!credit_card_number || credit_card_number.length==0) {
		credit_card_number_valid = undefined;
		card_type_nice='';
		card_type='';
		return;
		}
	
	var numberValidation = cardValid.number(credit_card_number,{maxLength: 16})//hardcode max of 16 --visa can supposedly have longer, but show error right away
	var yisracard = ValidateIsracard(credit_card_number);
	if(yisracard) {
		numberValidation.isValid = numberValidation.isPotentiallyValid = true;
		numberValidation.card = {type: 'yisracard', niceType:'Yisracard'};
		}
	if (numberValidation.card) {
		card_type_nice=numberValidation.card.niceType;
		if(card_type_nice=="American Express") card_type_nice="Amex";//shorter
		card_type=numberValidation.card.type;
		}

	//console.log(typeOfCheck,numberValidation);
	if(typeOfCheck=='loose' && credit_card_number_valid==undefined){//don't show invalid if we only started with a few digits. But show valid as soon as possible.
		if(!numberValidation.isPotentiallyValid) credit_card_number_valid=false;

		else if(card_type=='discover' || card_type=='diners-club' || card_type=='jcb') credit_card_number_valid=false;
		else if(numberValidation.isValid) credit_card_number_valid=true;
		}
	else {
		if(card_type=='discover' || card_type=='diners-club' || card_type=='jcb') credit_card_number_valid=false;
		else credit_card_number_valid = numberValidation.isValid; //on blur, if we've had any digits, show invalid.
		}
	}

function check_expiry(typeOfCheck){
	//console.log(expiry)
	
	if(!expiry) return expiry_valid = undefined;

	const result = cardValid.expirationDate(expiry);
	//console.log(result);
	
	expiry_month = result.month;
	//it's a string, normalize to 2 digit year. (could have gone other way, but tranzila wants MMYY)
	if(result.year && result.year.length==4) expiry_year = result.year.slice(2,4);
	else expiry_year = result.year;


	if(typeOfCheck=='loose' && expiry_valid==undefined){//don't show invalid if we only started with a few digits. But show valid as soon as possible.
		if(!result.isPotentiallyValid) expiry_valid=false;
		if(result.isValid) expiry_valid=true;
		}
	else expiry_valid = result.isValid; //on blur, if we've had any digits, show invalid.
	}

import Cleave from 'cleave.js/dist/cleave-esm.min.js';
var cleaveCreditCard;
$: cleaveCreditCard && cleaveCreditCard.setRawValue(credit_card_number);//bind from svelte to cleave
function formatCard(){
	//console.log('setting up cleaveCreditCard...' + credit_card_number);
	cleaveCreditCard = new Cleave('#credit-card', {
		creditCard: true
		//onCreditCardTypeChanged: function (type) { 	//console.log(type); 	}
		,onValueChanged: s => credit_card_number=s.target.rawValue //sync the raw value back to our model
		});
	if(credit_card_number) {
		//console.log('start value: ' + credit_card_number)
		cleaveCreditCard.setRawValue(credit_card_number);
		}
	return { destroy(){ 
		//console.log('cleaning up cleaveCreditCard');
		cleaveCreditCard.destroy();
		}}
	}

var cleaveExpiry;
$: cleaveExpiry && cleaveExpiry.setRawValue(expiry);//bind from svelte to cleave
function formatExpiry(){
	//console.log('setting up cleaveExpiry...' + expiry);
	cleaveExpiry = new Cleave('#expiry', {
		date: true,
		datePattern: ['m', 'Y']
		,onValueChanged: s => expiry=s.target.rawValue //bind from cleave to svelte
		});
	if(expiry) {
		//console.log('start value: ' + expiry)
		cleaveExpiry.setRawValue(expiry);
		}
	return { destroy(){ 
		//console.log('cleaning up cleaveExpiry');
		cleaveExpiry.destroy();
		}}
	}


function ValidateIsracard(num) {//see https://gist.github.com/israelidanny/5851338 for reference code and link to algorithm
	if(typeof num !== 'number') num=''+num; //cast to string
	if(num.length < 8 || num.length > 9) return false;
	var sum=0;
	num.split('').forEach(function(val,key){
		sum+=parseInt(val,10)*(num.length-key);
		})
	return sum % 11 == 0;
	}
export let tranzilaToken='';
function pasteTranzilaToken(event){
	if(!cleaveCreditCard) return;
	var paste = (event.clipboardData || window.clipboardData).getData('text').trim();
	//if(paste.length==19 && paste.replace(''))
	//const last4 =  
	tranzilaToken=paste;
	event.preventDefault();
	//cleaveIsraeliNumber.setRawValue(paste);
	}
</script>

<style>
/*
.is-valid {
	border-color: #28a745;
    padding-right: calc(1.5em + .75rem);
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right calc(.375em + .1875rem) center;
    background-size: calc(.75em + .375rem) calc(.75em + .375rem);
	}
.is-invalid { 
	border-color: #dc3545;
	padding-right: calc(1.5em + 0.75rem);
	background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
	background-repeat: no-repeat;
	background-position: right calc(0.375em + 0.1875rem) center;
	background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
	}
*/
.chosen {
	-webkit-box-shadow: 1px 1px 1px 1px #938e8f;
	box-shadow: 1px 1px 1px 1px #938e8f;
	border: 3px solid #000000;
	border-radius: 15%;
	}
</style>

<main>


<div style="max-width:300px" class="mx-auto">
<label class="ff-dunbar title-2 text-black" for="credit-card">Credit Card Number {#if card_type_nice}<small>({card_type_nice})</small>{/if}</label>

<input maxlength=20 placeholder="Credit Card Number"
	id="credit-card" use:formatCard 
	autocomplete="cc-number"
	on:blur={s=>check_card('strict')} on:keyup={s=>check_card('loose')}
	class="form-control" class:is-valid={credit_card_number_valid} class:is-invalid={credit_card_number_valid==false}
	/>	<br>
{#if card_type=='discover' || card_type=='diners-club' || card_type=='jcb'} <!--I didn't use whitelist only because yisracard entry triggered a mastero along the way-->
<div class="alert alert-danger">
	<Fa icon={faExclamationCircle} /> Sorry, {card_type_nice} is not accepted.
	</div>
{/if}

<label class="ff-dunbar title-2 text-black" for="credit-card">Expiration Date (MM/YY)</label>
<input maxlength=9 placeholder="Expiration MM/YY" 
	id="expiry" use:formatExpiry
	autocomplete="cc-exp"
	on:blur={s=>check_expiry('strict')} on:keyup={s=>check_expiry('loose')}
	class="form-control" class:is-valid={expiry_valid} class:is-invalid={expiry_valid==false}
	/><br>


{#if IsraeliCard || ask_security_code}
<label class="ff-dunbar title-2 text-black" for="security_code">Security Code<small>
	{#if card_type=='american-express'}
		(4 digits)
	{:else}
		(3 digits)
	{/if}</small>
	</label>
<input type="tel" maxlength=4 placeholder="Security Code" 
	id="security_code"
	autocomplete="cc-csc"
	class="form-control"
	bind:value={security_code}
	/><br>
{/if}

</div>

{#if show_card_types}
<br>
<center><h3 class="title-2 ff-dunbar fw-800 text-black">We accept:</h3>
<img height="60" class:chosen={card_type=='visa'} src="image/payment-icons/70599 - curved visa.png" alt="Visa"/> &nbsp;
<img height="60" class:chosen={card_type=='mastercard'} src="image/payment-icons/70593 - curved mastercard.png" alt="Mastercard"/> &nbsp;
<img height="60" class:chosen={card_type=='american-express'} src="image/payment-icons/70583 - american curved express.png" alt="American Express"/> &nbsp;
<img height="60" class:chosen={card_type=='yisracard'} src="image/payment-icons/isracard2.png" alt="Yisracard"/>
<br>
<!--img src="image/yisracard-all.png" alt="Accepted credit cards: American Express, Mastercard, Isracard, and Visa."/-->
</center>
{/if}

</main>